import dynamic from 'next/dynamic';

export * from './FormComponents';
export * from './ui/Vectors';

const JsonList = dynamic(() => import('./JsonList/JsonList'));

const LocationSearch = dynamic(() => import('./LocationSearch/LocationSearch'));
const SearchAddress = dynamic(() => import('./SearchAddress/SearchAddress'));

const GlobalSearch = dynamic(() => import('./GlobalSearch/GlobalSearch'));
const FavoriteDashboard = dynamic(() =>
  import('./FavoriteDashboard/FavoriteDashboard')
);
const RouteGuard = dynamic(() => import('./RouteGuard/RouteGuard'));
const Map = dynamic(() => import('./Map/Map'));
const ReverseGeocodingMap = dynamic(() =>
  import('./ReverseGeocodingMap/ReverseGeocodingMap')
);
const BoxNowMap = dynamic(() => import('./BoxNowMap/BoxNowMap'));
const JsonEditor = dynamic(() => import('./JsonEditor/JsonEditor'));

const MoreButton = dynamic(() => import('./MoreButton/MoreButton'));

const Stepper = dynamic(() => import('./Stepper/Stepper'));

const PermissionsGate = dynamic(() =>
  import('./PermissionsGate/PermissionsGate')
);
const TenantSelection = dynamic(() =>
  import('./TenantSelection/TenantSelection')
);

const Tabs = dynamic(() => import('./Tabs/Tabs'));
const TabContent = dynamic(() => import('./Tabs/TabContent'));
const TabsContainer = dynamic(() => import('./Tabs/TabsContainer'));
const CatalogDocuments = dynamic(() =>
  import('./CatalogDocuments/CatalogDocuments')
);

const ArnmWorkTypeField = dynamic(() =>
  import('./ArnmWorkTypeField/ArnmWorkTypeField')
);

const BreadcrumpsV2 = dynamic(() => import('./BreadcrumpsV2/BreadcrumpsV2'));
const TabsV2 = dynamic(() => import('./TabsV2/TabsV2'));

const CommentsV2 = dynamic(() => import('./CommentsV2/CommentsV2'));
const MentionsCommentV2 = dynamic(() =>
  import('./MentionsCommentV2/MentionsCommentV2')
);
const HistoryV2 = dynamic(() => import('./HistoryV2/HistoryV2'));
const TaskSection = dynamic(() => import('./TaskSection/TaskSection'), {
  ssr: false,
});
const ActivityListV2 = dynamic(() => import('./ActivityListV2/ActivityListV2'));
const BoardShortName = dynamic(() => import('./BoardShortName/BoardShortName'));
const ShortName = dynamic(() => import('./ShortName/ShortName'));
const TaskCarDetails = dynamic(() => import('./TaskCarDetails/TaskCarDetails'));
const TaskStages = dynamic(() => import('./TaskStages/TaskStages'));

const ArnmRepairWorkTypeField = dynamic(() =>
  import('./ArnmRepairWorkTypeField/ArnmRepairWorkTypeField')
);

const TaskDetailScrollableSection = dynamic(() =>
  import('./TaskDetailScrollableSection/TaskDetailScrollableSection')
);
const ListPageFiltersWrapper = dynamic(() =>
  import('./ListPageFiltersWrapper/ListPageFiltersWrapper')
);
const ListPageTabs = dynamic(() => import('./ListPageTabs/ListPageTabs'));
const ApprovalStatusDisplay = dynamic(() =>
  import('./ApprovalStatusDisplay/ApprovalStatusDisplay')
);
const SubscriptionTypeLabel = dynamic(() =>
  import('./SubscriptionTypeLabel/SubscriptionTypeLabel')
);
const DriverCarsContent = dynamic(() =>
  import('./DriverCarsContent/DriverCarsContent')
);
const DriverCarListItem = dynamic(() =>
  import('./DriverCarsContent/DriverCarListItem/DriverCarListItem')
);
const BillingCard = dynamic(() => import('./BillingCard/BillingCard'));

const TaskUserDetails = dynamic(() =>
  import('./TaskUserDetails/TaskUserDetails')
);
const TaskLabels = dynamic(() => import('./TaskLabels/TaskLabels'));

const BillingInfoForm = dynamic(() =>
  import('./BillingInfoForm/BillingInfoForm')
);

const Header = dynamic(() => import('./Header/Header'));
const LanguageSelection = dynamic(() =>
  import('./LanguageSelection/LanguageSelection')
);

const MonthlyDatesRibbon = dynamic(() => import('./MonthlyDatesRibbon'));

const DriversWorkflow = dynamic(() =>
  import('./DriversWorkflow/DriversWorkflow')
);
const DriversWorkflowStep = dynamic(() =>
  import('./DriversWorkflowStep/DriversWorkflowStep')
);
const DriversWorkflowOverview = dynamic(() =>
  import('./DriversWorkflowOverview/DriversWorkflowOverview')
);
const ErrorBoundary = dynamic(() => import('./ErrorBoundary/ErrorBoundary'));
const ErrorBoundaryFallback = dynamic(() =>
  import('./ErrorBoundaryFallback/ErrorBoundaryFallback')
);

const InstaTaskHeader = dynamic(() =>
  import('./InstaTaskHeader/InstaTaskHeader')
);
const InstaTaskSideBar = dynamic(() =>
  import('./InstaTaskSideBar/InstaTaskSideBar')
);
const InstaTaskMain = dynamic(() => import('./InstaTaskMain/InstaTaskMain'));
const InstaTaskSection = dynamic(() =>
  import('./InstaTaskSection/InstaTaskSection')
);

const InstaTaskHistory = dynamic(() =>
  import('./InstaTaskHistory/InstaTaskHistory')
);

const QuickTicketCreationForm = dynamic(() =>
  import('./QuickTicketCreationForm/QuickTicketCreationForm')
);

const ErfuddAlertSwitch = dynamic(() =>
  import('./ErfuddAlertSwitch/ErfuddAlertSwitch')
);

export {
  BreadcrumpsV2,
  TabsV2,
  GlobalSearch,
  JsonEditor,
  JsonList,
  LocationSearch,
  SearchAddress,
  Map,
  ReverseGeocodingMap,
  BoxNowMap,
  MoreButton,
  PermissionsGate,
  RouteGuard,
  Stepper,
  TenantSelection,
  Tabs,
  TabContent,
  TabsContainer,
  CatalogDocuments,
  ArnmWorkTypeField,
  CommentsV2,
  MentionsCommentV2,
  HistoryV2,
  TaskSection,
  ActivityListV2,
  ShortName,
  BoardShortName,
  TaskCarDetails,
  TaskStages,
  ArnmRepairWorkTypeField,
  TaskDetailScrollableSection,
  ListPageFiltersWrapper,
  ListPageTabs,
  ApprovalStatusDisplay,
  SubscriptionTypeLabel,
  DriverCarsContent,
  DriverCarListItem,
  BillingCard,
  TaskUserDetails,
  TaskLabels,
  BillingInfoForm,
  Header,
  LanguageSelection,
  MonthlyDatesRibbon,
  DriversWorkflow,
  DriversWorkflowStep,
  DriversWorkflowOverview,
  ErrorBoundary,
  ErrorBoundaryFallback,
  FavoriteDashboard,
  InstaTaskHeader,
  InstaTaskSideBar,
  InstaTaskMain,
  InstaTaskSection,
  InstaTaskHistory,
  QuickTicketCreationForm,
  ErfuddAlertSwitch,
};

export { FlagsProvider, useFlags } from './FlagsProvider';
